
export const APP_NAME = process.env.VUE_APP_NAME || "KEY LEARNING";
export const APP_LOGO = "@/assets/logo_klearning.png";
export const ENVIRONMENT = process.env.VUE_APP_ENVIRONMENT || 'development';

let url;

if (process.env.VUE_APP_API_URL) {
    url = process.env.VUE_APP_API_URL;
} else {
    // Runtime fallback: build-time env as primary, hostname pattern as safety net
    const hostname = window.location.hostname;
    if (hostname === 'localhost') {
        url = "http://localhost:9000/api/v1.0";
    } else if (ENVIRONMENT === 'staging' || /(?:^|-)dev\.klearning\.cl$/.test(hostname)) {
        // dev.klearning.cl, *-dev.klearning.cl (ipss-dev, uniacc-dev, duoc-dev, etc.) → staging backend
        url = "https://devback.klearning.cl/api/v1.0";
    } else if (ENVIRONMENT === 'demo' || /^demo\.klearning\.cl$/.test(hostname)) {
        // demo.klearning.cl → demo backend
        url = "https://demoback.klearning.cl/api/v1.0";
    } else {
        // klearning.cl, *.klearning.cl → production backend
        url = "https://backend.klearning.cl/api/v1.0";
    }
}

export const URL = url;

// Public marketing documents (brochures, methodology papers) live on the CDN's unsigned
// `public/` prefix, so marketing can replace a file there without a frontend release.
// They used to be hardcoded links to the legacy S3 bucket (sa-east-1), retired 2026-09-13.
export const CDN_PUBLIC_URL = process.env.VUE_APP_CDN_PUBLIC_URL || "https://cdn.klearning.cl/public";
export const brochureUrl = (fileName) => `${CDN_PUBLIC_URL}/brochures/${encodeURIComponent(fileName)}`;

// Configuración de reintentos en peticiones fallidas (errores de red o 5xx).
// api_max_retries: número máximo de reintentos antes de propagar el error.
// api_retry_delay_ms: tiempo base de espera entre reintentos (se multiplica por el número de intento).
export const api_max_retries = 3;
export const api_retry_delay_ms = 500;
export const RECAPTCHA_SITE_KEY = '6Le_75osAAAAADDQ3CYaAfrQFRlIQXtAoKwZh4Tj';

// Listados de usuarios acotados por grupo. El alcance lo impone la ruta, así que
// estos endpoints no necesitan mandar el grupo ni pedir la forma mínima.
const GROUP_USER_URLS = {
    ESTUDIANTES: '/authentication/students/',
    PROFESORES: '/authentication/professors/',
};

// Devuelve el endpoint propio del grupo, o null si no tiene uno y hay que caer al
// listado general de usuarios.
export const groupUserUrl = (group_name) => GROUP_USER_URLS[group_name] || null;
